// Import CSS
import './styles/main.scss'

// Import JS Modules/Functions
import { InitScrollToTop } from './scripts/scroll-to-top';
import { InitMobileMenu, InitMobileMenuSubMenus } from './scripts/mobile-menu';
import { Tab } from './scripts/tabs';
 
// Import 3rd Party Modules
import SmoothScroll from 'smooth-scroll'

document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.remove('no-js');
    document.body.classList.add('js');

    // Init modules
    InitScrollToTop()
    // InitMobileMenu()
    // InitMobileMenuSubMenus()

    const tabs = Array.from(document.getElementsByClassName('js-tabs'));
    tabs.forEach((tab, i) => {
        new Tab(tab);
    });  

    // Init smooth scroll on anchor links
    const scroll = new SmoothScroll('a[href*="#"]', { speed: 100 })
})

// Header Transition
// let lastKnownScrollPosition = 0
// let ticking = false
// const siteHeader = document.querySelector('.site-header')

// document.addEventListener("scroll", (event) => {
//     lastKnownScrollPosition = window.scrollY

//     if (!ticking) {
//         window.requestAnimationFrame(() => {
//             changeNavigationBG(lastKnownScrollPosition)
//             ticking = false
//         })

//         ticking = true
//     }
// }, { passive: true })

// function changeNavigationBG(scrollPos) {
//     if (scrollPos > siteHeader.offsetHeight + 50) {       
//         siteHeader.setAttribute('data-header-mode', 'light')
//     } else {
//         siteHeader.setAttribute('data-header-mode', 'transparent')
//     }
// }

const mobileButton = document.querySelector('.hamburgs-button')

// Get the header element with the class "site-header"
const headerElement = document.querySelector('header.site-header');

const mobileNavLinks = document.querySelectorAll('#mobile-menu-list > .menu-item ')

// Add a click event listener to the toggle button
mobileButton.addEventListener('click', function() {
    // Get the current value of the data attribute
    const currentValue = headerElement.getAttribute('data-mobile-menu-open');

    // Toggle the value between true and false
    const newValue = (currentValue === 'true') ? 'false' : 'true';

    // Update the data attribute value
    headerElement.setAttribute('data-mobile-menu-open', newValue);
});

const mobileSubMenuToggles = document.querySelectorAll('.sub-menu-toggle')

mobileSubMenuToggles.forEach(button => {
    button.addEventListener('click', () => toggleMobileSubMenu(button))
})

function toggleMobileSubMenu(button) {
    // Get the current value of the data attribute
    const currentValue = button.getAttribute('aria-expanded');

    // Toggle the value between true and false
    const newValue = (currentValue === 'true') ? 'false' : 'true';

    button.setAttribute('aria-expanded', newValue);

    var subMenu = button.parentNode.nextElementSibling; // Get the next sibling element (the submenu)
    subMenu.classList.toggle('active'); // Toggle the 'show' class on the submenu
}

document.querySelectorAll('.block--services-overview--main--card--content details')
  .forEach(detailsElement => detailsElement.addEventListener('click', (event) => {
    const contentElement = detailsElement.querySelector('.content-wrapper');

    // Check if the click is inside the contentElement
    if (contentElement.contains(event.target)) {
      // If so, do nothing to prevent details from closing
      return;
    }

    // Chrome sometimes has a hiccup and gets stuck.
    if (contentElement.classList.contains('animation')) {
        // So we make sure to remove those classes manually,
        contentElement.classList.remove('animation', 'collapsing');
        // ... enforce a reflow so that collapsing may be animated again,
        void detailsElement.offsetWidth;
        // ... and fallback to the default behaviour this time.
        return;
    }

    const onAnimationEnd = cb => contentElement.addEventListener("animationend", cb, { once: true });

    // request an animation frame to force Safari 16 to actually perform the animation
    requestAnimationFrame(() => contentElement.classList.add('animation'));
    onAnimationEnd(() => contentElement.classList.remove('animation'));

    const isDetailsOpen = detailsElement.getAttribute('open') !== null;
    if (isDetailsOpen) {
        // prevent default collapsing and delay it until the animation has completed
        event.preventDefault();
        contentElement.classList.add('collapsing');
        onAnimationEnd(() => {
            detailsElement.removeAttribute('open');
            contentElement.classList.remove('collapsing');
        });
    }
}));

document.querySelectorAll('.site-blog--content--aside--card')
  .forEach(detailsElement => detailsElement.addEventListener('click', (event) => {
    const contentElement = detailsElement.querySelector('.content-wrapper');

    // Check if the click is inside the contentElement
    if (contentElement.contains(event.target)) {
      // If so, do nothing to prevent details from closing
      return;
    }

    // Chrome sometimes has a hiccup and gets stuck.
    if (contentElement.classList.contains('animation')) {
        // So we make sure to remove those classes manually,
        contentElement.classList.remove('animation', 'collapsing');
        // ... enforce a reflow so that collapsing may be animated again,
        void detailsElement.offsetWidth;
        // ... and fallback to the default behaviour this time.
        return;
    }

    const onAnimationEnd = cb => contentElement.addEventListener("animationend", cb, { once: true });

    // request an animation frame to force Safari 16 to actually perform the animation
    requestAnimationFrame(() => contentElement.classList.add('animation'));
    onAnimationEnd(() => contentElement.classList.remove('animation'));

    const isDetailsOpen = detailsElement.getAttribute('open') !== null;
    if (isDetailsOpen) {
        // prevent default collapsing and delay it until the animation has completed
        event.preventDefault();
        contentElement.classList.add('collapsing');
        onAnimationEnd(() => {
            detailsElement.removeAttribute('open');
            contentElement.classList.remove('collapsing');
        });
    }
}));

document.addEventListener('DOMContentLoaded', function () {
    var quantity = {
      selector: '.quantity:not(.hidden)',
      init: function () {
        var base = this,
          container = document.querySelectorAll(base.selector);
  
        base.initialize();
        document.body.addEventListener('updated_cart_totals', function () {
          base.initialize();
        });
      },
      initialize: function () {
        // Quantity buttons
        var quantityElements = document.querySelectorAll('div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)');
        quantityElements.forEach(function (element) {
          element.classList.add('buttons_added');
          element.insertAdjacentHTML('beforeend', '<div class="plus"></div>');
          element.insertAdjacentHTML('afterbegin', '<div class="minus"></div>');
          var inputNumber = element.querySelector('input[type="number"]');
          inputNumber.setAttribute('type', 'text');
        });
  
        document.querySelectorAll('.plus, .minus').forEach(function (button) {
          button.addEventListener('click', function () {
            // Get values
            var quantityContainer = this.closest('.quantity'),
              qtyInput = quantityContainer.querySelector('.qty'),
              currentVal = parseFloat(qtyInput.value),
              max = parseFloat(qtyInput.getAttribute('max')),
              min = parseFloat(qtyInput.getAttribute('min')),
              step = qtyInput.getAttribute('step');
  
            // Format values
            if (!currentVal || currentVal === '' || isNaN(currentVal)) {
              currentVal = 0;
            }
            if (isNaN(max)) {
              max = '';
            }
            if (isNaN(min)) {
              min = 0;
            }
            if (step === 'any' || step === '' || step === undefined || isNaN(parseFloat(step))) {
              step = 1;
            }
  
            // Change the value
            if (button.classList.contains('plus')) {
              if (max && (max === currentVal || currentVal > max)) {
                qtyInput.value = max;
              } else {
                qtyInput.value = currentVal + parseFloat(step);
              }
            } else {
              if (min && (min === currentVal || currentVal < min)) {
                qtyInput.value = min;
              } else if (currentVal > 0) {
                qtyInput.value = currentVal - parseFloat(step);
              }
            }
  
            // Trigger change event
            var event = new Event('change');
            qtyInput.dispatchEvent(event);
  
            return false;
          });
        });
      }
    };
  
    // Initialize quantity functionality
    quantity.init();
  });
  


const siteSearchButton = document.querySelector('.site-header-search-button')
const siteSearchDialog = document.querySelector('#siteSearchDialog')

siteSearchButton.addEventListener('click', () => {
    siteSearchDialog.showModal()
})

 // Get all close buttons
const closeButtons = document.querySelectorAll('.dialog--close-button');

// Loop through each close button and add event listener
closeButtons.forEach(function(button) {
    button.addEventListener('click', function() {
         // Find the closest parent dialog element and close it
        const dialog = button.closest('.dialog');
        if (dialog) {
            dialog.close();
        }
    });
});